import BrokenImageIcon from '@mui/icons-material/BrokenImage';
import Box from '@mui/material/Box';
import Icon from 'common/components/Elements/Icon/Icon';
import SanitizeHTML from 'common/components/Elements/SanitizeHTML/SanitizeHTML';
import StyleHintIcon from 'core/components/Elements/Command/StyleHintIcon/StyleHintIcon';
import type { ApplicationState } from 'core/redux/reducers/rootReducer';
import type { EnhancedCommand } from 'core/utilities/core.types';
import theme from 'core/utilities/theme';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

export interface ComponentProps {
  command: EnhancedCommand;
}

function CommandLinkContent({
  command: {
    icon, label, htmlLabel, active, title, iconEl, preventIconLabelOverlay, styleHint,
  },
}: ComponentProps) {
  const jsfUrl = useSelector((state: ApplicationState) => state.configuration.jsfUrl);
  const iconLabelOverlay = !preventIconLabelOverlay && icon && label;
  const shIcon = StyleHintIcon(styleHint);
  const [imgLoadingError, setImgLoadingError] = useState(false);

  return (
    <span style={(icon && iconLabelOverlay && !imgLoadingError) ? {
      display: 'inline-block',
      padding: theme.spacing(0, 1),
      backgroundImage: `url(${jsfUrl}${icon.url})`,
      backgroundPosition: 'center',
      backgroundSize: '100% 100%',
      backgroundRepeat: 'no-repeat',
      color: 'white',
      opacity: active ? 1 : 0.3,
    } : {}}
    >
      {(icon && !iconLabelOverlay && !imgLoadingError) && (
        <img
          src={`${jsfUrl}${icon.url}`}
          alt={icon.title || title}
          style={{ maxHeight: '22px', opacity: active ? 1 : 0.3, verticalAlign: 'middle' }}
          onError={() => setImgLoadingError(true)}
        />
      )}
      {(icon && !iconLabelOverlay && imgLoadingError) && (
        <span
          title={icon.title || title}
          style={{ display: 'inline-block', opacity: active ? 1 : 0.3, lineHeight: '20px' }}
          data-broken-img={`${jsfUrl}${icon.url}`}
        >
          <Icon element={BrokenImageIcon} />
        </span>
      )}
      {iconEl && (iconEl)}
      {shIcon}
      {!shIcon && (
        <Box
          ml={icon && label && !iconLabelOverlay ? 1 : 0}
          component="span"
        >
          {htmlLabel ? <SanitizeHTML html={htmlLabel} /> : label}
        </Box>
      )}
    </span>
  );
}

export default CommandLinkContent;
